import angular from 'angular'
import template from './template.html'

angular.module('nominas.cotizacion')
  .component('nominasCotizacionEmpleadosItem', {
    template: template,
    bindings: {
      data: '<',
    },
    controller: Component,
  });

function Component() {
  let $ctrl = this;

  $ctrl.empleado = $ctrl.data.Empleado;
  $ctrl.percepciones = $ctrl.data.Percepciones.reduce(function (prev, next) {
    return prev + next.Importe;
  }, 0);
  $ctrl.deducciones = $ctrl.data.Deducciones.reduce(function (prev, next) {
    return prev + next.Importe;
  }, 0);
  $ctrl.total = $ctrl.percepciones - $ctrl.deducciones;
}



// WEBPACK FOOTER //
// ./src/nominas/cotizacion/components/empleados/item/controller.js